export default {
  showRegistrationModalOnQr: false,
  general: {
    showFavourites: true,
    showLayoutSwitchToggle: true,
    showSoldNeighbourhoods: false,
    showSoldReleases: false,
    showSoldSlides: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
